import { fetchMetaAndCtxs, fetchPerpCategories } from "../api/coins";
import { formatChange } from "../utils/format";

// xyz:COIN
const getCoin = (symbol) =>
  symbol?.split(":")?.pop()?.toUpperCase();

const toNum = (v) => Number(v ?? 0);

export async function loadCoins({
  setCoins,
  setCategories,
  setError,
  // setLoading,
}) {
  // setLoading(true);

  try {
    const [defaultRes, dexRes, perpCategories] = await Promise.all([
      fetchMetaAndCtxs(),
      fetchMetaAndCtxs("xyz"),
      fetchPerpCategories(),
    ]);

    const [metaDefault, ctxDefault] = await defaultRes;
    const [metaDex, ctxDex] = await dexRes;

    const categoryMap = Object.fromEntries(
      perpCategories
        .map(([symbol, category]) => {
          const ticker = getCoin(symbol);
          if (!ticker) return null;
          return [ticker, category?.toLowerCase()];
        })
        .filter(Boolean)
    );

    const uniqueCategories = [
      "all",
      ...new Set(
        perpCategories.map(([, c]) => c?.toLowerCase()).filter(Boolean)
      ),
    ];

    setCategories(uniqueCategories);

    const cryptoMap = new Map();

    metaDefault.universe.forEach((coin, i) => {
      const ticker = getCoin(coin.name);
      if (!ticker) return;

      cryptoMap.set(ticker, {
        meta: coin,
        ctx: ctxDefault?.[i] || {},
      });
    });

    const dexMap = new Map();

    metaDex.universe.forEach((coin, i) => {
      const ticker = getCoin(coin.name);
      if (!ticker) return;

      dexMap.set(ticker, {
        meta: coin,
        ctx: ctxDex?.[i] || {},
      });
    });

// union
    const allTickers = [
      ...cryptoMap.keys(),
      ...dexMap.keys(),
    ];

    const seen = new Set();

    const formattedCoins = allTickers
      .filter((t) => {
        if (seen.has(t)) return false;
        seen.add(t);
        return true;
      })
      .map((ticker) => {

        const crypto = cryptoMap.get(ticker);
        const dex = dexMap.get(ticker);

        const source = crypto || dex;

        const meta = source.meta;
        const ctx = source.ctx;

        return {
          id: ticker,
          ticker,

          name: meta.name ?? "Unknown",

          szDecimals: meta.szDecimals,
          maxLeverage: meta.maxLeverage,

          markPx: toNum(ctx.markPx),
          oraclePx: toNum(ctx.oraclePx),
          funding: toNum(ctx.funding),
          openInterest: toNum(ctx.openInterest),
          volume: toNum(ctx.dayNtlVlm),

          category: categoryMap[ticker] || "uncategorized",

          change: formatChange(
            toNum(ctx.prevDayPx),
            toNum(ctx.markPx)
          ),

          source: crypto ? "crypto" : "dex",
        };
      });

      setCoins((prevCoins) => {
        const prevMap = new Map(
          prevCoins.map((coin) => [coin.id, coin])
        );
      
        return formattedCoins.map((coin) => {
          const prev = prevMap.get(coin.id);
      
          if (!prev) return coin;
      
          const priceChanged = prev.markPx !== coin.markPx;
          const changeChanged =
            prev.change?.value !== coin.change?.value ||
            prev.change?.percent !== coin.change?.percent;
      
          if (!priceChanged && !changeChanged) {
            return prev; 
          }
      
          return {
            ...prev,
            ...coin,
          };
        });
      });
    setError(null);

    console.log("Loaded coins:", formattedCoins);
  } catch (err) {
    console.error("Coin loading error:", err);
    setError(err.message);
  } 
  // finally {
  //   setLoading(false);
  // }
}